module.exports = __webpack_public_path__ + "static/media/notebook-icon-collapse.c3accbcc.svg";